import { useState } from "react";
import { Heart, Pencil, Trash2 } from "lucide-react";
import { fileUrl } from "../api";

export default function PunchlineCard({ punch, child, onLike, onDelete, onEdit }) {
  const color = child?.color || "#1c1b1a";
  const [popping, setPopping] = useState(false);

  const handleLike = () => {
    setPopping(true);
    onLike();
    setTimeout(() => setPopping(false), 400);
  };

  const avatar = child?.avatar_path ? fileUrl(child.avatar_path) : null;
  const initial = (child?.name || "?").charAt(0).toUpperCase();

  const dateObj = punch.date ? new Date(punch.date + "T00:00:00") : null;
  const dateStr = dateObj
    ? dateObj.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })
    : "";

  return (
    <article
      data-testid={`punchline-card-${punch.id}`}
      className="card-scrap p-6 sm:p-7 relative h-full flex flex-col"
      style={{ boxShadow: `6px 6px 0 0 ${color}` }}
    >
      {/* Decorative tape — alternates side */}
      {parseInt(punch.id.slice(-1), 16) % 2 === 0 ? <span className="tape-tr" /> : <span className="tape-bl" />}

      {/* Big opening quote mark */}
      <div
        className="font-serif-display text-7xl leading-none -mt-2 mb-1 select-none"
        style={{ color }}
      >
        “
      </div>

      {/* Quote */}
      <blockquote
        className="font-serif-display text-2xl sm:text-[1.7rem] leading-[1.2] text-[var(--ink)] mb-6 flex-1 -mt-2"
        data-testid={`punchline-text-${punch.id}`}
      >
        {punch.text}
      </blockquote>

      {/* Footer */}
      <div className="flex items-end justify-between gap-4 pt-4 border-t border-dashed border-[var(--ink)]/30">
        <div className="flex items-center gap-3 min-w-0">
          <div
            className="relative w-11 h-11 rounded-full border-[1.5px] border-[var(--ink)] overflow-hidden flex items-center justify-center shrink-0"
            style={{ background: color }}
          >
            {avatar ? (
              <img src={avatar} alt={child?.name} className="w-full h-full object-cover" />
            ) : (
              <span className="font-serif-display text-xl text-[var(--ink)]">{initial}</span>
            )}
          </div>
          <div className="min-w-0">
            <div
              className="font-handwrite text-2xl leading-none truncate"
              style={{ color: "var(--ink)" }}
              data-testid={`punchline-child-${punch.id}`}
            >
              {punch.child_name}
            </div>
            <div className="font-ui text-[10px] uppercase tracking-widest text-[var(--ink-soft)] mt-1">
              {dateStr}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-1">
          <button
            onClick={onEdit}
            className="p-2 rounded-full hover:bg-[var(--ink)] hover:text-white transition-colors"
            title="Modifier"
            data-testid={`edit-punchline-${punch.id}`}
          >
            <Pencil size={14} />
          </button>
          <button
            onClick={onDelete}
            className="p-2 rounded-full hover:bg-[var(--kid-levy)] hover:text-white transition-colors"
            title="Supprimer"
            data-testid={`delete-punchline-${punch.id}`}
          >
            <Trash2 size={14} />
          </button>
          <button
            onClick={handleLike}
            className="flex items-center gap-1.5 pl-2 pr-3 py-1.5 rounded-full border-[1.5px] border-[var(--ink)] hover:bg-[var(--ink)] hover:text-white transition-colors"
            title="J'adore"
            data-testid={`like-punchline-${punch.id}`}
          >
            <Heart
              size={14}
              className={popping ? "heart-pop" : ""}
              fill={punch.likes > 0 ? "currentColor" : "none"}
            />
            <span className="font-ui text-xs" data-testid={`like-count-${punch.id}`}>
              {punch.likes}
            </span>
          </button>
        </div>
      </div>
    </article>
  );
}
